export const TypeNames = {
  Lead: 'Lead',
  Client: 'Client',
};
